import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import React from 'react';
import getStatus from 'src/function/getStatusOrder';
import { IOrder } from 'src/function/ordersService';

interface OrderItemProps {
  onClick: () => void;
  order: IOrder;
}

const OrderItem: React.FC<OrderItemProps> = ({ onClick, order }) => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        width: "100%",
        borderRadius: 2,
        boxShadow: 3,
        overflow: "hidden",
        transition: '0.3s ease',
        '&:hover': {
          boxShadow: 6,
        },
        '&:active': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
      }}
      onClick={onClick}
    >
      <CardMedia
        component="img"
        sx={{
          height: "auto",
          width: { xs: "100%", md: 300 },
          maxHeight: 200,
          maxWidth: "100%",
          objectFit: "contain",
        }}
        image={order.photo}
        alt={order.name}
      />

      <Box sx={{ display: "flex", flexDirection: "column", p: 2, flex: 1 }}>
        <CardContent>
          <Typography variant="h6" fontWeight="bold">
            {order.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Статус: {getStatus(order.statusOrder)}
          </Typography>
          <Typography variant="body1" fontWeight="medium" color="primary">
            Цена: {order.price} {order.currency}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Реквизиты: {order.requisites}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Описание: {order.description}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
};

export default OrderItem;
